import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'decimalFormat'
})
export class DecimalFormatPipe implements PipeTransform
{

  transform(value: number, format: 'one-decimal' | 'two-decimals' = 'one-decimal'): string
  {
    if (!value && value !== 0) return '';

    let formattedValue: string;

    if (format === 'two-decimals')
    {
      formattedValue = value.toFixed(2);
    } else
    {
      formattedValue = value.toFixed(1);
    }

    return formattedValue.replace('.', ',');
  }


}
